import { AFFILIATE_DASHBOARD_API } from 'modules/affiliate-dashboard/api/affiliate-dashboard-api'
import { AffiliateDashboardPromotionInterface } from 'modules/affiliate-dashboard/types/affiliate-dashboard-promotion-interface'
import { useEffect, useState } from 'react'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import useSWR from 'swr'

export const useAffiliateDashboardPromotion = (opened: boolean) => {
  const { fetcher } = useFetch<RequestMethodsEnum.get, AffiliateDashboardPromotionInterface>({
    method: RequestMethodsEnum.get,
  })
  const { user } = useUser()

  const [shouldFetch, setShouldFetch] = useState(false)

  useEffect(() => {
    if (opened) {
      setShouldFetch(true)
    }
  }, [opened])

  return useSWR(() => {
    if (!user || !shouldFetch) return
    return `${AFFILIATE_DASHBOARD_API}/promotion-stats`
  }, fetcher)
}
